import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary';

const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true' || window.self === window.top;

async function bootstrap() {
  if (USE_MOCK) {
    const { installMock } = await import('./features/deal-context/mock');
    installMock();
  } else {
    // Load the real BX24 SDK dynamically — keeps index.html clean and never blocks page load.
    await new Promise<void>((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://api.bitrix24.com/api/v1/';
      script.onload = () => resolve();
      script.onerror = () => resolve(); // fail gracefully, error will surface in useDeal
      document.head.appendChild(script);
    });
    // Wait for BX24 to finish handshake with the parent Bitrix frame.
    await new Promise<void>((resolve) => window.BX24.init(resolve));
  }

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('#root not found');

  const queryClient = new QueryClient({
    defaultOptions: { queries: { retry: 2, refetchOnWindowFocus: false } },
  });

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

bootstrap().catch((err) => {
  console.error('[bootstrap]', err);
  const rootEl = document.getElementById('root');
  if (rootEl) rootEl.textContent = `Ошибка запуска: ${err.message}`;
});
